import { SegmentCardEvent, SegmentCardOptions, segmentTrackAction } from '../../../../../../../../middlewares/segment';
import { SegmentCardSourceValue } from 'app/middlewares/segment/trackEntities/cardEvents';
import { Dispatch, ThunkAction } from 'app/types/actions';
import { IGetState } from 'app/types/types';

export const onOpen = (): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        dispatch(segmentTrackAction(SegmentCardEvent.CUSTOM_PROPERTY_ADD_CLICKED, {
            name: SegmentCardOptions.SOURCE,
            value: SegmentCardSourceValue.DETAILS,
        }));
    };
    return action;
};
